import {
  combineReducers,
  AnyAction,
} from 'redux';

import {
  coreReducers,
} from '@gymcloud/core';
import ui from './ui';

const appReducer = combineReducers({
  ui,
  ...coreReducers,
})

export type RootState = ReturnType<typeof appReducer>

const rootReducer = (
  state: RootState | undefined,
  action: AnyAction
): RootState => {
  if (action.type === 'LOG_OUT') {
    return appReducer(
      { ui: state?.ui } as RootState,
      action
    )
  }

  return appReducer(state, action)
}

export default rootReducer
